import { Text as SitecoreText, TextField } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

type SafeTextProps = {
  field: TextField;
  editable?: boolean;
  encode?: boolean;
  tag?: string;
  className?: string;
};

/**
 * React 19 compatible replacement for JSS Text with encode={false}.
 *
 * ROOT CAUSE: JSS 22's Text component has a bug where the `output` variable
 * becomes an array (strings + <br/> React elements) when the input contains
 * newlines. When encode={false}, this array is passed to dangerouslySetInnerHTML
 * as __html. React 16 silently called .toString() on the array, but React 19
 * crashes and renders it as "[object Object],[object Object],...".
 *
 * FIX: When encode={false}, we bypass JSS Text entirely and use
 * dangerouslySetInnerHTML directly with the raw string value.
 */
export const SafeText: React.FC<SafeTextProps> = ({ field, editable = true, encode = true, tag, className }) => {
  if (!encode && field) {
    // Bypass JSS Text entirely - render raw HTML directly as a string
    const htmlValue = typeof field === 'object' && 'value' in field ? String(field.value ?? '') : String(field ?? '');

    const tagName = tag || 'span';
    return React.createElement(tagName, {
      className,
      dangerouslySetInnerHTML: { __html: htmlValue },
    });
  }

  return <SitecoreText field={field} editable={editable} encode={encode} tag={tag} className={className} />;
};
